var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length > 0)?_c('ul',{staticClass:"validation-errors"},_vm._l((_vm.errors),function(item){return _c('li',{key:item,staticClass:"error"},[_vm._v(_vm._s(item))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }